"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePrismTranslationsStandalone = exports.selectLanguage = void 0;
var client_1 = require("@apollo/client");
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var ThemeProvider_1 = require("../../ThemeProvider");
var selectLanguage = function (currentIdentity, locales) {
    return ((currentIdentity === null || currentIdentity === void 0 ? void 0 : currentIdentity.language) ||
        ((locales === null || locales === void 0 ? void 0 : locales.some(function (locale) { return locale.locale.code === navigator.language; })) &&
            navigator.language) ||
        'en-US');
};
exports.selectLanguage = selectLanguage;
var getTranslations = function (lang) {
    return fetch('https://www.culturecloud.com/t/prism-header', {
        headers: {
            'accept-language': lang,
        },
    }).then(function (res) { return __awaiter(void 0, void 0, void 0, function () {
        var updateLang, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!res.ok) return [3 /*break*/, 2];
                    updateLang = res.headers.get('content-language');
                    return [4 /*yield*/, res.json()];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, { lang: updateLang, data: data }];
                case 2: throw res;
            }
        });
    }); });
};
var useTranslations = function (currentIdentity, locales) {
    var _a = __read((0, client_1.useMutation)(ThemeProvider_1.UPDATE_LANGUAGE), 1), updateLanguage = _a[0];
    var _b = __read(react_1.default.useState(null), 2), lang = _b[0], setLang = _b[1];
    var reactI18n = (0, react_i18next_1.useTranslation)();
    react_1.default.useEffect(function () {
        if (!currentIdentity || !locales)
            return;
        var lang = (0, exports.selectLanguage)(currentIdentity, locales);
        getTranslations(lang)
            .then(function (_a) {
            var data = _a.data, lang = _a.lang;
            setLang(lang);
            if (!(currentIdentity === null || currentIdentity === void 0 ? void 0 : currentIdentity.language)) {
                updateLanguage({
                    variables: { id: currentIdentity === null || currentIdentity === void 0 ? void 0 : currentIdentity.identityUuid, language: lang },
                });
            }
            reactI18n.i18n
                .addResourceBundle('en', 'prism-header', data)
                .emit('languageChanged');
        })
            .catch(function () { return console.error('Could not load header translations!'); });
    }, [reactI18n.i18n, currentIdentity, updateLanguage, locales]);
    return __assign(__assign({}, reactI18n), { lang: lang });
};
var usePrismTranslationsStandalone = function () {
    var _a = __read(react_1.default.useState(null), 2), lang = _a[0], setLang = _a[1];
    var reactI18n = (0, react_i18next_1.useTranslation)();
    react_1.default.useEffect(function () {
        var _a;
        var lang = ((_a = navigator.languages) === null || _a === void 0 ? void 0 : _a[0]) || navigator.language;
        getTranslations(lang)
            .then(function (_a) {
            var data = _a.data, lang = _a.lang;
            setLang(lang);
            reactI18n.i18n
                .addResourceBundle('en', 'prism-header', data)
                .emit('languageChanged');
        })
            .catch(function () { return console.error('Could not load header translations!'); });
    }, [reactI18n.i18n]);
    return __assign(__assign({}, reactI18n), { lang: lang });
};
exports.usePrismTranslationsStandalone = usePrismTranslationsStandalone;
exports.default = useTranslations;
//# sourceMappingURL=useTranslations.js.map